import React from 'react';
import { getDocketDisplayValue } from '../../common/constants';
import SettingsItem from '../../component/SettingsItem/SettingsItem';
import { View, Text } from 'react-native';
import { LayoutStrategy } from '@oolio-group/domain';
import { translate } from '@oolio-group/localization';
import SettingsScreenStyles from './Settings.styles';

interface Props {
  currentStrategy: LayoutStrategy;
  showStrategies: boolean;
  setShowStrategies: (a: boolean) => void;
  onToggleStrategy: (strategy: LayoutStrategy) => void;
  columnsOnScreen: number;
  setColumnModalVisible: (a: boolean) => void;
  rowsOnScreen: number;
}

export default function LayoutSelectionSettings({
  currentStrategy,
  showStrategies,
  setShowStrategies,
  onToggleStrategy,
  columnsOnScreen,
  setColumnModalVisible,
  rowsOnScreen,
}: Props) {
  const styles = SettingsScreenStyles();
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>
        {translate('kitchenDisplay.docketsLayout')}
      </Text>
      <SettingsItem
        type="parent"
        testID="select-layout-strategy"
        title={translate('kitchenDisplay.docketsLayout')}
        subtitle={getDocketDisplayValue(currentStrategy)}
        checked={showStrategies}
        onChange={() => setShowStrategies(!showStrategies)}
      />
      {showStrategies ? (
        <View style={styles.subSection}>
          {Object.values(LayoutStrategy).map((strategy, i) => (
            <SettingsItem
              key={i}
              type="select"
              testID={`layout-strategy-${strategy.toLowerCase()}`}
              title={getDocketDisplayValue(strategy)}
              checked={currentStrategy === strategy}
              onChange={() => {
                onToggleStrategy(strategy);
              }}
            />
          ))}
        </View>
      ) : null}
      <View>
        <SettingsItem
          type="action"
          testID={'columns-on-screen'}
          title={translate('kitchenDisplay.gridSize')}
          subtitle={
            `${columnsOnScreen.toString()}x${rowsOnScreen.toString()}` || ''
          }
          onChange={() => setColumnModalVisible(true)}
        />
      </View>
    </View>
  );
}
